import { Box } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { visuallyHiddenSx } from '../../../../core-components/theme/components/Fields/fieldStyles';
import { alertKey } from '../../domain/inAppAlerts';
import { useInAppAlerts } from '../../hooks/logic/useInAppAlerts';
import type { InAppAlertsLogic } from '../../hooks/logic/useInAppAlerts';

import { announceText } from './announceText';
import { EmergencyOverlay } from './EmergencyOverlay';
import { InAppBanner } from './InAppBanner';
import { PushBridge } from './PushBridge';

const ShownAlert: React.FC<{ logic: InAppAlertsLogic }> = ({ logic }) => {
  const { shown } = logic;
  if (shown === null) return null;
  if (shown.kind === 'emergency') {
    return (
      <EmergencyOverlay
        key={alertKey(shown.item)}
        item={shown.item}
        now={logic.now}
        phase={shown.phase}
        plantName={logic.plantName}
        moreCount={shown.emergencyCount}
        canStart={logic.canStart}
        startFailed={logic.startFailed}
        offline={logic.offline}
        onStart={logic.start}
        onDismiss={logic.dismiss}
        onShown={logic.shownLive}
        onExited={logic.closed}
      />
    );
  }
  return (
    <InAppBanner
      key={alertKey(shown.item)}
      item={shown.item}
      now={logic.now}
      phase={shown.phase}
      openTarget={logic.openTarget}
      pendingCount={shown.pendingCount}
      canStart={logic.canStart}
      startFailed={logic.startFailed}
      onStart={logic.start}
      onOpen={logic.open}
      onDismiss={logic.dismiss}
      onTimeout={logic.expire}
      onSeeAll={logic.seeAll}
      onExited={logic.closed}
    />
  );
};

export const InAppAlerts: React.FC = () => {
  const { t } = useTranslation();
  const logic = useInAppAlerts();

  return (
    <>
      <PushBridge />
      <Box role="status" aria-live="polite" sx={visuallyHiddenSx}>
        {announceText(t, logic.announced)}
      </Box>
      <ShownAlert logic={logic} />
    </>
  );
};
